function init() {
  const backtotop = document.querySelector('.js-backtotop');
  if (backtotop) {
    backtotop.addEventListener('click', () => window.scrollTo(0, 0));
  }
}

export { init };
